module.exports = __webpack_public_path__ + "static/Smartsheet-7116ddad37a1593c81285c17368036b1.jpg";